import { render, staticRenderFns } from "./logo1.vue?vue&type=template&id=1054dacb&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054dacb",
  null
  
)

export default component.exports